/** Category path helpers. Backend stores canonical paths as `A>B>C`. */

const CATEGORY_SEPARATOR = '>';

/**
 * Normalize a category path to the backend canonical format.
 * Accepts legacy slash-delimited and spaced variants during migration.
 */
export function normalizeCategoryPath(path: string | null | undefined): string {
  if (!path) return '';
  return path
    .replace(/\s*>\s*/g, CATEGORY_SEPARATOR)
    .replace(/\s*\/\s*/g, CATEGORY_SEPARATOR)
    .split(CATEGORY_SEPARATOR)
    .map((part) => part.trim())
    .filter(Boolean)
    .join(CATEGORY_SEPARATOR);
}

/** Split a category path into trimmed segments. */
export function splitCategoryPath(path: string | null | undefined): string[] {
  const normalized = normalizeCategoryPath(path);
  return normalized ? normalized.split(CATEGORY_SEPARATOR) : [];
}

/** Join category segments into the backend canonical path format. */
export function joinCategoryPath(parts: string[]): string {
  return parts
    .map((part) => part.trim())
    .filter(Boolean)
    .join(CATEGORY_SEPARATOR);
}
